var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileKills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 22C44 34.1503 34.1503 44 22 44C20.1039 44 18.2638 43.7601 16.5085 43.3091L17.5346 41.93L15.7258 43.0924C12.9574 42.2701 10.4172 40.9177 8.2227 39.1529C8.54262 38.3518 9.19914 37.1609 9.79773 36.0752C10.4143 34.9567 10.9695 33.9498 11.0319 33.5953L7.21975 37.1697L7.69682 38.7164C2.98554 34.6814 0 28.6894 0 22C0 9.84974 9.84974 0 22 0C27.0656 0 31.7313 1.71203 35.4501 4.58904L33.864 5.75018L36.1133 5.12288C38.2908 6.94573 40.1103 9.18216 41.4509 11.7113C40.9069 12.2975 40.1952 12.9845 39.5313 13.6254C38.6124 14.5124 37.7852 15.3109 37.6211 15.6313L42.2448 13.3747C43.3747 16.0233 44 18.9386 44 22ZM24.0016 5.75018L24.4713 7.12539L26.3498 4.83337L24.0016 5.75018ZM26.1046 37.8473L26.9587 39.023L24.9851 40.5912L26.1046 37.8473Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9713 31.8447C21.3307 31.8447 20.7045 31.7825 20.0977 31.6651L18.6123 32.7391C19.6735 33.0717 20.8018 33.2512 21.9713 33.2512C23.1556 33.2512 24.2974 33.0668 25.3703 32.726L23.8907 31.6562C23.2697 31.7795 22.6279 31.8447 21.9713 31.8447Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6011 12.4434L20.1055 10.9033C16.2515 11.5494 13.0555 14.1607 11.5869 17.6686L13.1332 17.6651C14.4005 15.0916 16.759 13.1486 19.6011 12.4434Z",
    fill: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1932 23.1539L10.7197 22.0781C10.7405 25.1073 11.9643 27.8556 13.9364 29.8686L14.4335 28.3264C13.2275 26.892 12.4226 25.1097 12.1932 23.1539Z",
    fill: "#B3B3B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7429 23.2003C31.509 25.1155 30.7233 26.8626 29.5498 28.2771L30.0486 29.8243C31.9859 27.8249 33.1894 25.111 33.2212 22.1211L31.7429 23.2003Z",
    fill: "#B3B3B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8092 17.6644L32.3555 17.668C30.8947 14.1787 27.7248 11.5763 23.8984 10.9131L24.4045 12.4583C27.2184 13.1764 29.5512 15.11 30.8092 17.6644Z",
    fill: "#B3B3B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0344 34.3635L26.9924 24.9271L35 19.0808L25.0854 19.0581L22 9.63574L18.9146 19.0581L9 19.0808L17.0075 24.9271L13.9653 34.3635L22 28.5542L30.0344 34.3635Z",
    fill: "#B3B3B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileKills);
export default __webpack_public_path__ + "static/media/profileKills.7f79f3db5eb9515da33f895d62bffb02.svg";
export { ForwardRef as ReactComponent };